module.exports = __webpack_public_path__ + "static/img/qnstatus1.bc621ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnstatus1.png
// module id = 76
// module chunks = 0